import { createTheme, makeStyles } from '@material-ui/core/styles';
import { input } from 'UI/constants/dimensions';
import { colors, colorsByMode } from 'UI/res/colors';
import { isDarkTheme } from 'UI/theme/darkTones';
import { flexAlignCenter } from 'UI/utils/styles';

const createSearchInputTheme = mode =>
  createTheme({
    palette: {
      type: mode,
      primary: {
        light: colorsByMode[mode].greyFocus,
        main: colorsByMode[mode].greyFocus
      }
    },
    overrides: {
      MuiInputLabel: {
        outlined: {
          transform: 'translate(14px, 13px) scale(1)'
        }
      },
      MuiFormLabel: {
        root: {
          '&.Mui-focused': {
            color: colors.darkGrey
          }
        }
      },
      MuiInputBase: {
        root: {
          paddingRight: '300px !important',
          '@media (max-width: 1024px)': {
            paddingRight: '240px !important'
          }
        }
      }
    }
  });

const searchInputThemes = {
  light: createSearchInputTheme('light'),
  dark: createSearchInputTheme('dark')
};

/**
 * Nested theme for the search input. Light mode keeps the original theme object; dark mode uses a
 * dark variant, following the app theme's `palette.type`.
 * @param {Object} outerTheme
 */
export const themeOverride = outerTheme => ({
  ...outerTheme,
  ...(searchInputThemes[outerTheme?.palette?.type] ?? searchInputThemes.light)
});

export const useAutocompleteStyles = makeStyles(theme => ({
  root: {
    ...theme.input,
    '& .MuiOutlinedInput-root': {
      margin: '0px !important',
      transform: 'translate(14px, 13px) scale(1)',
      padding: '0 !important',
      '& fieldset': {
        borderColor: colors.componentFill,
        borderWidth: 1
      }
    }
  },
  inputRoot: {
    height: input.height,
    width: '100%',
    borderRadius: input.borderRadius,
    border: 0
  }
}));

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: 1024,
    height: input.height,
    borderRadius: input.borderRadius,
    borderColor: colors.transparent,
    borderWidth: 0,
    position: 'relative',
    '&:hover': {
      color: colors.darkGrey,
      ...(isDarkTheme(theme)
        ? { '& $iconButton path': { fill: theme.palette.text.primary } }
        : { '& path': { fill: colors.middleGrey } })
    }
  },
  input: {
    flex: 1,
    fontSize: 18,
    position: 'absolute',
    width: 576
  },
  wrapper: {
    position: 'absolute',
    right: 0,
    flex: 1,
    display: 'flex',
    height: '100%'
  },
  iconButton: {
    padding: theme.spacing(1)
  },
  selectBox: {
    width: ({ isSmallViewPort }) => (isSmallViewPort ? '' : 192)
  },
  searchEndAdorment: flexAlignCenter,
  resultsLabel: {
    whiteSpace: 'nowrap',
    color: theme.palette.grey[500]
  }
}));
